import RavenCdn from '../modules/raven-cdn';

if ('production' === process.env.NODE_ENV) {

  RavenCdn.config(process.env.REACT_APP_SENTRY_DSN).install();

}


// WEBPACK FOOTER //
// ./src/config/sentry.js